import script from "./contact-lookup.vue?vue&type=script&setup=true&lang=ts"
export * from "./contact-lookup.vue?vue&type=script&setup=true&lang=ts"

import "./contact-lookup.vue?vue&type=style&index=0&id=28fd44d6&lang=scss"

const __exports__ = script;

export default __exports__